export const validateEmptyLanguageObject = (obj: any, message: string) => { 
    if (obj == undefined) {
        return message;
    }

    const keys = Object.keys(obj);
    if (keys.length == 0) {
        return message;
    }

    let atLeastOneValid = false;
    for (const key of keys) {
        if (obj[key] != undefined && obj[key] != '') {
            atLeastOneValid = true;
            break;
        }
    }

    if (!atLeastOneValid) {
        return message;
    }

    return undefined;
}


// WEBPACK FOOTER //
// ./src/helpers/Validations/validateEmptyLanguageObject.ts